// src/app/core/ProfileComp/checOut/controller/CheckoutPromoController.ts
import { PaymentsApi, type CheckoutPreviewResponse } from '@/app/data/profilPayment/api/PaymentsApi';

export interface PromoApplyResult {
  appliedPromo: string | null;
  error: string;
  preview: CheckoutPreviewResponse | null;
}

export class CheckoutPromoController {
  private readonly paymentsApi = new PaymentsApi();

  async applyPromoCode(
    rawPromoCode: string,
    payload: { productCode: string; currency?: 'RUB' | 'XTR' },
  ): Promise<PromoApplyResult> {
    const normalizedPromo = rawPromoCode.trim().toUpperCase();

    if (!normalizedPromo) {
      return { appliedPromo: null, error: 'Введите промокод перед применением.', preview: null };
    }

    try {
      const preview = await this.paymentsApi.previewCheckout({
        packageCode: payload.productCode,
        currency: payload.currency ?? 'RUB',
        promoCode: normalizedPromo,
      });

      return {
        appliedPromo: preview.applied?.promoCode ?? normalizedPromo,
        error: '',
        preview,
      };
    } catch (error) {
      return {
        appliedPromo: null,
        error: error instanceof Error ? error.message : 'Ошибка проверки промокода',
        preview: null,
      };
    }
  }
}